<template>
  <v-dialog
    v-model="dialog"
    max-width="520"
    :retain-focus="false"
    persistent
  >
    <v-card class="primary p-4">
      <div class="navy--text text--darken-1 pt-2 px-2 d-flex align-center font-hemi-head">
        <v-icon class="white--text" left>auto_awesome</v-icon>
        <span class="white--text" style="font-size: 18px">
          SCEGLI STRATEGIA
        </span>
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <div class="navy darken-1 white--text pa-4">
        <div>
          Scegli lo schema che vorresti utilizzare e Asta Live distribuirà i
          crediti tra i vari slot in modo coerente con quella strategia.
        </div>

        <v-alert dense text type="warning" class="mt-4 mb-0">
          Se avevi già pianificato i crediti, verranno sovrascritti.
        </v-alert>

        <div class="py-4">
          <v-select
            v-model="strategiaModel"
            :items="strategieOptions"
            label="Scegli schema"
            solo
            flat
            hide-details
          ></v-select>
        </div>

        <div v-if="strategiaPreview" class="strategia-preview mb-4">
          <div class="font-hemi-head mb-2">ANTEPRIMA DISTRIBUZIONE CREDITI</div>
          <div
            v-for="ruoloPreview in strategiaPreview"
            :key="ruoloPreview.ruolo_abc"
            class="strategia-preview-ruolo mb-2"
          >
            <div class="d-flex align-center mb-1">
              <div
                class="strategia-preview-ruolo-dot mr-2"
                :class="'ruolo_' + ruoloPreview.ruolo_id"
              >
                {{ ruoloPreview.ruolo_abc }}
              </div>
              <crediti
                :crediti="ruoloPreview.totale"
                variant="dark"
              ></crediti>
              <div class="ml-2 text-caption">
                {{ ruoloPreview.percentuale }}%
              </div>
            </div>
            <div class="strategia-preview-slots">
              <span
                v-for="slotPreview in ruoloPreview.slots"
                :key="ruoloPreview.ruolo_abc + slotPreview.slot"
                class="strategia-preview-slot"
              >
                <crediti
                  :crediti="slotPreview.crediti"
                ></crediti>
              </span>
            </div>
          </div>
          <div class="text-right font-weight-bold pt-1">
            Totale: {{ strategiaPreviewTotale }} / {{ asta_info.lega.crediti }}
          </div>
        </div>

        <v-alert v-if="strategiaModel" dense text type="info" class="mb-4">
          Ricorda che potrai sempre modificarli a mano dopo
        </v-alert>

        <v-card-actions class="justify-center pa-0">
          <v-btn
            rounded
            class="secondary"
            :disabled="!strategiaModel"
            @click="saveStrategia"
          >
            Salva
          </v-btn>
          <v-btn rounded outlined class="secondary--text" @click="dismiss">
            Annulla
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Vuex from "vuex";
import db from "../../js/db";
import Constants from "../../js/constants";
import Crediti from "../common/Crediti";

export default {
  name: "dialog-plan-strategia",
  mixins: [mixins, toast],
  components: { Crediti },
  mounted() {
    console.log("--> DialogPlanStrategia mounted.");
    db.on("DialogPlanStrategia", this.show);
  },
  destroyed() {
    console.log("<-- DialogPlanStrategia destroyed.");
    db.off("DialogPlanStrategia", this.show);
  },
  data() {
    return {
      dialog: false,
      strategiaModel: null,
      strategieOptions: [
        { value: "442", text: "Schema 442" },
        { value: "343", text: "Schema 343" },
        { value: "352", text: "Schema 352" },
        { value: "433", text: "Schema 433" },
      ],
      strategie: {
        442: {
          P: [6.1, 0.7, 0.4],
          D: [6.4, 5.3, 3.5, 2.5, 1.7, 1.2, 0.7, 0.4],
          C: [10.0, 7.1, 4.4, 3.1, 2.3, 1.5, 1.1, 0.5],
          A: [21.3, 12.0, 4.3, 2.0, 1.2, 0.4],
        },
        343: {
          P: [2.0, 0.7, 0.4],
          D: [3.2, 2.4, 2.0, 1.6, 1.1, 0.7, 0.7, 0.4],
          C: [7.9, 5.2, 3.5, 2.9, 1.7, 1.3, 0.5, 0.4],
          A: [30.7, 17.3, 8.4, 2.8, 1.6, 0.7],
        },
        352: {
          P: [2.7, 0.8, 0.4],
          D: [3.5, 2.7, 2.3, 1.9, 1.3, 0.8, 0.5, 0.4],
          C: [14.4, 10.0, 6.4, 5.7, 3.5, 1.3, 0.5, 0.5],
          A: [19.1, 13.7, 4.7, 1.7, 0.8, 0.4],
        },
        433: {
          P: [9.1, 0.5, 0.4],
          D: [9.6, 7.7, 5.6, 3.9, 2.0, 1.2, 0.8, 0.4],
          C: [7.6, 4.7, 3.5, 2.1, 1.1, 0.8, 0.4, 0.4],
          A: [19.1, 10.0, 5.7, 2.0, 1.1, 0.4],
        },
      },
    };
  },
  methods: {
    dismiss() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
      this.strategiaModel = null;
    },
    saveStrategia() {
      const output = this.getStrategiaOutput(this.strategiaModel);
      if (!output) {
        return;
      }

      db.updatePlan(output)
        .then(() => {
          this.successToast("Complimenti!", "Crediti distribuiti");
          this.dismiss();
        })
        .catch(() => {
          this.errorToast("Errore", "Operazione non riuscita");
        });
    },
    getStrategiaOutput(strategiaKey) {
      const strategia = this.strategie[strategiaKey];
      if (!strategia) {
        return null;
      }

      let tot = 0;
      let output = {};
      const creditiLega = this.asta_info.lega.crediti;
      Object.entries(this.planDefault).forEach(([ruolo_abc, slots]) => {
        output[ruolo_abc] = [];
        const budgetRuolo = parseInt(
          (creditiLega * _.sum(strategia[ruolo_abc])) / 100
        );
        const countSlots = _.size(slots);

        const reversedKeys = Object.keys(slots).reverse();
        let budgetRuoloConsumed = 0;
        let budgetSlot = 0;
        reversedKeys.forEach((slot, index) => {
          const originalIndex = countSlots - index - 1;
          output[ruolo_abc][slot] = {};
          if (index === countSlots - 1) {
            budgetSlot = parseInt(budgetRuolo - budgetRuoloConsumed);
          } else {
            const perc = strategia[ruolo_abc][originalIndex];
            budgetSlot = parseInt((creditiLega * perc) / 100) || 1;
            budgetRuoloConsumed = budgetRuoloConsumed + budgetSlot;
          }
          output[ruolo_abc][slot]["crediti"] = budgetSlot;
          tot = tot + budgetSlot;
        });
      });

      output.A._1.crediti = output.A._1.crediti + (creditiLega - tot);

      return output;
    },
    getStrategiaPreview(output) {
      if (!output) {
        return null;
      }

      const creditiLega = this.asta_info.lega.crediti;
      return Object.entries(output).map(([ruolo_abc, slots]) => {
        const ruolo_id = Constants.RUOLO[ruolo_abc];
        const slotPreviews = Object.entries(slots)
          .map(([slot, slotData]) => ({
            slot,
            crediti: slotData.crediti,
          }))
          .sort((a, b) => b.crediti - a.crediti);
        const totale = _.sumBy(slotPreviews, "crediti");

        return {
          ruolo_abc,
          ruolo_id,
          totale,
          percentuale: Math.round((totale * 100) / creditiLega),
          slots: slotPreviews,
        };
      });
    },
  },
  computed: {
    strategiaPreview() {
      return this.getStrategiaPreview(
        this.getStrategiaOutput(this.strategiaModel)
      );
    },
    strategiaPreviewTotale() {
      if (!this.strategiaPreview) {
        return 0;
      }
      return _.sumBy(this.strategiaPreview, "totale");
    },
    ...Vuex.mapGetters(["planDefault"]),
  },
};
</script>
<style lang="scss" scoped>
.strategia-preview {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  padding: 10px;
}

.strategia-preview-ruolo-dot {
  align-items: center;
  border-radius: 50%;
  color: white;
  display: inline-flex;
  font-size: 12px;
  font-weight: bold;
  height: 28px;
  justify-content: center;
  width: 28px;

  &.ruolo_1 {
    background: var(--ruolo-1);
  }

  &.ruolo_2 {
    background: var(--ruolo-2);
  }

  &.ruolo_3 {
    background: var(--ruolo-3);
  }

  &.ruolo_4 {
    background: var(--ruolo-4);
  }
}

.strategia-preview-slots {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.strategia-preview-slot {
  display: inline-flex;
}
</style>
